var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"width":80,"height":80,"opacity":0.7,"color":"cornflowerblue"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath,on:{"loadShowHide":_vm.triggerLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }